<template>
  <div class="ma-0 pa-0 row">
    <div class="col-12 col-sm-4">
      <ImportHeaderCard
        icon="mdi-check-bold"
        :title="$t('success')"
        :value="success"
        theme="success"
      />
    </div>
    <div class="col-12 col-sm-4">
      <ImportHeaderCard
        icon="mdi-exclamation"
        :title="$t('error')"
        :value="error"
        theme="error"
      />
    </div>
    <div class="col-12 col-sm-4">
      <ImportHeaderCard
        icon="mdi-upload"
        :title="$t('total')"
        :value="total"
        theme="info"
      />
    </div>
  </div>
</template>

<script>
import ImportHeaderCard from "./ImportHeaderCard.vue";
export default {
  name: "ImportHeader",
  components: { ImportHeaderCard },
  props: {
    total: {
      required: true,
      type: Number,
    },
    error: {
      required: true,
      type: Number,
    },
    success: {
      required: true,
      type: Number,
    },
  },
};
</script>
